import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useSnackbar } from 'notistack';
import { Box, IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { Body2, Subheader2 } from '../Typography';
import { IconContainer, ToastContainer } from './Toast.styles';
import ToastSeverityIcon from './ToastSeverityIcon';
const Toast = forwardRef(({ id, title, message, variant }, ref) => {
    const { closeSnackbar } = useSnackbar();
    return (_jsxs(ToastContainer, { ref: ref, children: [_jsx(ToastSeverityIcon, { variant: variant }), _jsxs(Box, { display: 'flex', flexDirection: 'column', mt: 0.5, flexGrow: 1, minWidth: 0, children: [title && (_jsx(Subheader2, { mb: 0.5, noWrap: true, children: title })), _jsx(Body2, { color: title ? 'text.secondary' : 'text.primary', children: message })] }), _jsx(IconContainer, { children: _jsx(IconButton, { onClick: () => closeSnackbar(id), children: _jsx(CloseOutlined, { fontSize: 'small' }) }) })] }));
});
export default Toast;
